import { type PropsWithChildren } from 'react';

export const Min = ({ children }: PropsWithChildren) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  (<>{children}</>)
);

Min['displayName'] = 'MeterBarChart.Min';
